import React from "react";
import DocumentViewer from "../components/DocumentViewer";
import { useMarkdownContent } from "../hooks/useMarkdownContent";

const CodeOfConductPage: React.FC = () => {
  const { content, loading, error } = useMarkdownContent("code-of-conduct.md");

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500 mx-auto"></div>
          <p className="mt-2 text-gray-600">Loading Code of Conduct...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-4xl mx-auto p-6">
        <div className="text-center text-red-600">
          <p>Error loading Code of Conduct: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <DocumentViewer
      content={content}
      title="Code of Conduct"
      filename="baakas-code-of-conduct"
    />
  );
};

export default CodeOfConductPage;
